import { DatePipe } from '@angular/common';
import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class CommonLibraryService {

  constructor(private datePipe: DatePipe) { }

  getSumClass() {
    return "color: black; font-weight: bold;";
  }

  isEmptyControl(control: AbstractControl): boolean{
    const value: string = control.value[0];
    return this.isEmptyTextValue(value);
  }

  isEmptyTextValue(value: any){
    var isEmpty = _.isNil(value) ? true : ((value || '').trim().length === 0);
    return isEmpty;
  }

  calculatedDueDate(dateStrFacture : string, idDelai: string, idCondition: string) : string{
    if (_.isNull(idDelai) || _.isNull(idCondition)){
      return null;
    }
    const delaiWithCondition : string = idDelai.concat('-',idCondition);

    let dateFacture : Date = new Date(dateStrFacture);
    dateFacture.setHours(10,0,0,0);

    let prevDate : Date = dateFacture;

    switch(delaiWithCondition){
      case "000-04":
        prevDate = dateFacture;
        break;
      case "030-02":
        prevDate = this.getEndMonth(dateFacture);
        prevDate.setDate(prevDate.getDate() + 30);
        break;
      case "030-04":
        prevDate.setDate(dateFacture.getDate() + 30);
        break;
      case "030-05":
        prevDate.setDate(dateFacture.getDate() + 30);
        if (prevDate.getDate() > 5){
          prevDate = new Date(prevDate.getFullYear(), prevDate.getMonth()+1, 5);
        }
        else {
          prevDate = new Date(prevDate.getFullYear(), prevDate.getMonth(), 5);
        }
        break;
      case "045-02":
        prevDate = this.getEndMonth(dateFacture);
        prevDate.setDate(prevDate.getDate() + 45);
        break;
      case "060-02":
        prevDate = this.getEndMonth(dateFacture);
        prevDate.setDate(prevDate.getDate() + 60);
        break;
      default:
        return null;
    }

    return this.datePipe.transform(prevDate, 'yyyy-MM-dd');
  }

  getEndMonth(currentDate: Date) : Date{
    return new Date(currentDate.getFullYear(), currentDate.getMonth()+1, 0);
  }

}
